import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Tabu",
  "description": "",
  "published": "2007-03-12T00:00:00.000Z",
  "redirect_from": ["/blog/tabu/swizec/265"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night my memory was tricked into remembering `}<a parentName="p" {...{
        "href": "http://www.t-a-b-u.com/"
      }}>{`Tabu`}</a>{`, a Slovene band I used to quite enjoy when I was quite some younger. Naturally I went to youtube and tried to see what I could have a listen to but alas there was naught to be found, which of course lead to doing what any responsible adult would - going to their website, stealing all the videos they make available and putting them on youtube. Hope they don't mind the free publicity.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=t6gwncRfmhE"
        }}>{`Lahko Sem Srce`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=1YZ97JIW49Y"
        }}>{`Angel`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=c2PbpxD6Z2o"
        }}>{`Divje`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=wRQzf_hvqR8"
        }}>{`Tabu`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://youtube.com/watch?v=c0t1qG19azQ"
        }}>{`V soju luci`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      